/**
 * Design Tokens: Spacing
 * Auto-generated from Figma Design System: Crop Circle System
 *
 * Spacing tokens define consistent spacing throughout the application.
 * Based on an 8px base unit system (8, 16, 24, 32, etc.)
 */

/**
 * Base spacing unit (8px)
 * All spacing should be multiples of this base unit
 */
export const BASE_SPACING = 8;

/**
 * Spacing Scale
 * Uses a consistent 8px-based scale for margin, padding, and gaps
 */
export const spacing = {
  /** 0px - No spacing */
  none: 0,

  /** 2px - Extra extra small (0.25 * base) */
  xxs: 2,

  /** 4px - Extra small (0.5 * base) */
  xs: 4,

  /** 8px - Small (1 * base) */
  sm: 8,

  /** 12px - Medium small (1.5 * base) */
  md: 12,

  /** 16px - Medium (2 * base) - Used in Main Navigation for item spacing */
  lg: 16,

  /** 20px - Medium large (2.5 * base) */
  xl: 20,

  /** 24px - Large (3 * base) - Used in Main Navigation for padding */
  '2xl': 24,

  /** 28px - Extra large (3.5 * base) */
  '3xl': 28,

  /** 32px - Extra extra large (4 * base) */
  '4xl': 32,

  /** 40px - Huge (5 * base) */
  '5xl': 40,

  /** 48px - Extra huge (6 * base) */
  '6xl': 48,

  /** 56px - Component size (7 * base) - Used for Main Navigation height */
  '7xl': 56,

  /** 64px - Extra large component (8 * base) */
  '8xl': 64,
} as const;

/**
 * Component-specific spacing
 * Derived from Figma component measurements
 */
export const componentSpacing = {
  /**
   * Main Navigation spacing
   * From the Figma Main Navigation component
   */
  mainNavigation: {
    height: 56,           // Navigation bar height
    padding: 24,          // Button horizontal padding
    itemSpacing: 8,       // Space between navigation items
    containerPadding: 8,  // Links container padding
  },

  /**
   * Button spacing
   */
  button: {
    paddingVertical: 12,
    paddingHorizontal: 24,
    iconSpacing: 8,
  },

  /**
   * Card spacing
   */
  card: {
    padding: 16,
    gap: 12,
  },

  /**
   * Container spacing
   */
  container: {
    paddingHorizontal: 16,
    paddingVertical: 16,
  },
} as const;

/**
 * Layout spacing
 * For page and section-level spacing
 */
export const layout = {
  /** Page horizontal padding */
  pageHorizontal: 16,

  /** Page vertical padding */
  pageVertical: 20,

  /** Section gap */
  sectionGap: 32,

  /** Content max width */
  contentMaxWidth: 1200,
} as const;

/**
 * Spacing types for TypeScript
 */
export type SpacingToken = typeof spacing;
export type SpacingKey = keyof typeof spacing;
